module.exports = {
	"": "razormarl",
	"vbucks": "atyan"
}